(function() {
  if (window.MellowQuickAdd) {
    return;
  }

  var selectors = {
    button: '[data-mellow-quick-add]',
    close: '[data-mellow-quick-add-close]',
    form: '[data-mellow-quick-add-form]',
    aris: '[data-mellow-quick-add-aris]',
    errorDisplay: '[data-error-display]',
    submit: '[data-add-to-cart]',
    availability: '[data-mellow-quick-add-availability]'
  };

  var state = {
    root: null,
    panel: null,
    overlay: null,
    activeButton: null,
    source: null,
    stackBuilderRoot: null,
    stackEditEntries: null,
    productConfigCache: {},
    productPageCache: {},
    opened: false
  };

  var strings = function() {
    var themeStrings = window.theme && window.theme.strings ? window.theme.strings : {};
    return {
      addToBag: themeStrings.quickAddAddToBag || 'Add to Bag',
      adding: themeStrings.quickAddAdding || 'Adding...',
      added: themeStrings.quickAddAdded || 'Added',
      fieldRequired: themeStrings.quickAddFieldRequired || 'Please complete this required field.',
      makeSelection: themeStrings.quickAddMakeSelection || 'Make a Selection',
      soldOut: themeStrings.soldOut || 'Sold Out',
      unavailable: themeStrings.unavailable || 'Unavailable',
      inStock: themeStrings.quickAddInStock || 'Item is in stock',
      outOfStock: themeStrings.quickAddOutOfStock || 'Item is out of stock',
      networkError: themeStrings.quickAddNetworkError || 'Something went wrong. Please try again.'
    };
  };

  function getRoutes() {
    var routes = window.theme && window.theme.routes ? window.theme.routes : {};
    var cart = routes.cart || '/cart';
    var root = routes.root_url || '/';
    return {
      cart: cart,
      root: root.charAt(root.length - 1) === '/' ? root : root + '/'
    };
  }

  function setLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.disabled = isLoading || button.dataset.productAvailable === 'false';
  }

  function createRoot() {
    if (state.root) {
      return;
    }

    state.root = document.createElement('div');
    state.root.className = 'mellow-quick-add-root';
    state.root.innerHTML = [
      '<div class="mellow-quick-add-root__overlay" data-mellow-quick-add-overlay></div>',
      '<div class="mellow-quick-add-root__panel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(strings().makeSelection) + '" tabindex="-1" data-mellow-quick-add-panel></div>'
    ].join('');

    state.overlay = state.root.querySelector('[data-mellow-quick-add-overlay]');
    state.panel = state.root.querySelector('[data-mellow-quick-add-panel]');
    document.body.appendChild(state.root);

    state.overlay.addEventListener('click', closeDrawer);
    state.root.addEventListener('click', function(event) {
      if (event.target.closest(selectors.close)) {
        closeDrawer();
      }
    });
    state.root.addEventListener('keydown', handleRootKeydown);
    state.root.addEventListener('submit', handleDrawerSubmit);
    state.root.addEventListener('theme:variant:change', handleVariantChange);
  }

  function openRoot() {
    createRoot();
    state.root.classList.add('is-open');
    document.documentElement.classList.add('mellow-quick-add-is-open');
    document.body.classList.add('mellow-quick-add-is-open');
    window.requestAnimationFrame(function() {
      state.root.classList.add('is-visible');
      focusFirst();
    });
    state.opened = true;
  }

  function closeDrawer() {
    if (!state.root || !state.opened) {
      return;
    }

    var closingSource = state.source;
    var closingBuilderRoot = state.stackBuilderRoot;

    state.root.classList.remove('is-visible');
    document.documentElement.classList.remove('mellow-quick-add-is-open');
    document.body.classList.remove('mellow-quick-add-is-open');

    if (closingBuilderRoot) {
      document.dispatchEvent(new CustomEvent('mellow:quick-add:closed', {
        bubbles: true,
        detail: {
          source: closingSource,
          builderRoot: closingBuilderRoot
        }
      }));
    }

    window.setTimeout(function() {
      if (!state.root) {
        return;
      }

      state.root.classList.remove('is-open');
      state.panel.innerHTML = '';
      state.opened = false;

      if (state.activeButton && typeof state.activeButton.focus === 'function') {
        state.activeButton.focus({ preventScroll: true });
      }
    }, 240);
  }

  function focusableElements() {
    if (!state.panel) {
      return [];
    }

    return Array.prototype.slice.call(state.panel.querySelectorAll([
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(','))).filter(function(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function focusFirst() {
    var first = state.panel.querySelector(selectors.close) || focusableElements()[0] || state.panel;
    first.focus({ preventScroll: true });
  }

  function handleRootKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var elements = focusableElements();
    if (!elements.length) {
      event.preventDefault();
      state.panel.focus();
      return;
    }

    var first = elements[0];
    var last = elements[elements.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async function handleClick(event) {
    var button = event.target.closest(selectors.button);
    if (!button || button.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    state.activeButton = button;
    state.source = button.dataset.mellowQuickAddSource || '';
    state.stackBuilderRoot = button.closest('[data-mellow-stack-builder]');
    state.stackEditEntries = null;

    if (button.dataset.productAvailable === 'false') {
      return;
    }

    setLoading(button, true);

    try {
      var productId = button.dataset.productId;
      var hasArisOptions = await productHasArisOptions(productId, button.dataset.productHandle);
      var canDirectAdd = button.dataset.nativeDirectEligible === 'true' && !hasArisOptions;

      if (canDirectAdd) {
        await directAdd(button.dataset.variantId);
      } else {
        await openSelectionDrawer(button.dataset.productHandle, button.dataset.variantId);
      }
    } catch (error) {
      console.error(error);
      showCardError(button, error && error.message ? error.message : strings().networkError);
    } finally {
      setLoading(button, false);
    }
  }

  async function openForStack(button, builderRoot, selection) {
    if (!button || button.dataset.productAvailable === 'false') {
      return;
    }

    state.activeButton = button;
    state.source = 'stack-builder';
    state.stackBuilderRoot = builderRoot || button.closest('[data-mellow-stack-builder]');
    state.stackEditEntries = selection && selection.entries ? selection.entries : null;
    setLoading(button, true);

    try {
      await openSelectionDrawer(button.dataset.productHandle, selection && selection.variantId);
    } catch (error) {
      closeDrawer();
      throw error;
    } finally {
      setLoading(button, false);
    }
  }

  async function directAdd(variantId) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    await addToCart(formData);
    await refreshCart(true);
  }

  async function openSelectionDrawer(handle, variantId) {
    openRoot();
    state.panel.innerHTML = '<div class="mellow-quick-add-content"><p class="mellow-quick-add-content__eyebrow">' + escapeHtml(strings().makeSelection) + '</p></div>';

    var routes = getRoutes();
    var selectionQuery = variantId ? ('?variant=' + encodeURIComponent(variantId) + '&section_id=api-mellow-quick-add') : '?section_id=api-mellow-quick-add';
    var response = await window.fetch(routes.root + 'products/' + encodeURIComponent(handle) + selectionQuery, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(strings().networkError);
    }

    var html = await response.text();
    var parsed = new window.DOMParser().parseFromString(html, 'text/html');
    var content = parsed.querySelector('[data-api-content]');

    if (!content) {
      throw new Error(strings().networkError);
    }

    state.panel.innerHTML = content.innerHTML;
    initialiseInjectedContent(state.panel);
    await renderArisOptions(state.panel, handle);
    hydrateStackSelection(state.panel);

    if (state.source === 'stack-builder') {
      var stackActionText = state.panel.querySelector('[data-add-to-cart-text]');
      if (stackActionText) {
        stackActionText.textContent = 'Add to stack';
      }
    }

    focusFirst();
  }

  function initialiseInjectedContent(panel) {
    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
      window.Alpine.initTree(panel);
    }

  }

  function hydrateStackSelection(panel) {
    if (!state.stackEditEntries || !state.stackEditEntries.length) {
      return;
    }

    var form = panel.querySelector(selectors.form);
    if (!form) {
      return;
    }

    state.stackEditEntries.forEach(function(entry) {
      var name = String(entry[0] || '');
      var value = entry[1];
      if (name.indexOf('properties[') !== 0 || value instanceof File) {
        return;
      }

      Array.prototype.slice.call(form.elements).filter(function(control) {
        return control.name === name;
      }).forEach(function(control) {
        if (control.type === 'radio' || control.type === 'checkbox') {
          control.checked = String(control.value) === String(value);
        } else if (control.type !== 'file') {
          control.value = value;
        }

        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    updateCheckboxProperties(form);
  }

  async function renderArisOptions(panel, handle) {
    var holder = panel.querySelector(selectors.aris);
    if (!holder) {
      return;
    }

    var productId = holder.dataset.productId;
    var config = await getArisConfig(productId, handle);
    var optionSets = config.optionSets.filter(function(optionSet) {
      return productInOptionSet(productId, optionSet);
    });

    if (!optionSets.length) {
      holder.innerHTML = '';
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'mellow-quick-add-aris';

    optionSets.forEach(function(optionSet) {
      (optionSet.options || []).forEach(function(option) {
        wrapper.appendChild(renderArisField(option));
      });
    });

    holder.innerHTML = '';
    holder.appendChild(wrapper);
    updateCheckboxProperties(holder);
  }

  function productInOptionSet(productId, optionSet) {
    return (optionSet.products || []).map(String).indexOf(String(productId)) !== -1;
  }

  async function getArisConfig(productId, handle) {
    if (state.productConfigCache[productId]) {
      return state.productConfigCache[productId];
    }

    var config = getArisConfigFromWindow();
    if (!config.productIds.length && !config.optionSets.length) {
      var html = await fetchProductPage(handle);
      config = parseArisConfigFromHtml(html);
    }

    state.productConfigCache[productId] = config;
    return config;
  }

  function getArisConfigFromWindow() {
    var optionSets = [];
    var productIds = [];

    if (window.ap_front_settings && window.ap_front_settings.config && Array.isArray(window.ap_front_settings.config.optionset)) {
      optionSets = window.ap_front_settings.config.optionset;
    }

    if (window.AvisStyleOptions && Array.isArray(window.AvisStyleOptions.product_ids_option)) {
      productIds = window.AvisStyleOptions.product_ids_option.map(String);
    } else if (window.ap_front_settings && window.ap_front_settings.product_info && Array.isArray(window.ap_front_settings.product_info.product_ids_option)) {
      productIds = window.ap_front_settings.product_info.product_ids_option.map(String);
    }

    return {
      optionSets: optionSets,
      productIds: productIds
    };
  }

  async function productHasArisOptions(productId, handle) {
    var config = await getArisConfig(productId, handle);

    if (config.productIds.map(String).indexOf(String(productId)) !== -1) {
      return true;
    }

    return config.optionSets.some(function(optionSet) {
      return productInOptionSet(productId, optionSet);
    });
  }

  async function fetchProductPage(handle) {
    if (state.productPageCache[handle]) {
      return state.productPageCache[handle];
    }

    var routes = getRoutes();
    var response = await window.fetch(routes.root + 'products/' + encodeURIComponent(handle), {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(strings().networkError);
    }

    state.productPageCache[handle] = await response.text();
    return state.productPageCache[handle];
  }

  function parseArisConfigFromHtml(html) {
    var optionSets = [];
    var productIds = [];
    var optionSetRegex = /window\.ap_front_settings\.config\["optionset"\]\.push\((\{[\s\S]*?\})\);/g;
    var match;

    while ((match = optionSetRegex.exec(html)) !== null) {
      try {
        optionSets.push(JSON.parse(match[1]));
      } catch (error) {
        console.warn('Could not parse Aris option set', error);
      }
    }

    var idsMatch = html.match(/product_ids_option:\s*(\[[\s\S]*?\])\s*,/);
    if (idsMatch) {
      try {
        productIds = JSON.parse(idsMatch[1]).map(String);
      } catch (error) {
        console.warn('Could not parse Aris product id list', error);
      }
    }

    return {
      optionSets: optionSets,
      productIds: productIds
    };
  }

  function renderArisField(option) {
    var field = document.createElement('div');
    var type = String(option.type || 'text').toLowerCase();
    var label = option.label_product || option.label_cart || option.option_name || '';
    var propertyName = option.label_cart || label;
    var inputId = 'mellow-aris-' + (option.option_id || option.key || label).replace(/[^a-zA-Z0-9_-]/g, '-');

    field.className = 'mellow-quick-add-aris__field';
    field.dataset.mellowQuickAddArisField = '';
    field.dataset.fieldType = type;
    field.dataset.propertyName = propertyName;
    field.dataset.required = option.required === true ? 'true' : 'false';

    field.appendChild(renderArisLabel(label, option.required === true, inputId));

    if (type.indexOf('textarea') !== -1) {
      field.appendChild(renderTextarea(option, propertyName, inputId));
    } else if (type.indexOf('select') !== -1 || type.indexOf('dropdown') !== -1 || type.indexOf('combo') !== -1) {
      field.appendChild(renderSelect(option, propertyName, inputId));
    } else if (type.indexOf('checkbox') !== -1) {
      field.appendChild(renderChoiceGroup(option, propertyName, inputId, 'checkbox'));
    } else if (type.indexOf('radio') !== -1 || type.indexOf('button') !== -1 || type.indexOf('swatch') !== -1) {
      field.appendChild(renderChoiceGroup(option, propertyName, inputId, 'radio'));
    } else if (type.indexOf('file') !== -1) {
      field.appendChild(renderTextInput(option, propertyName, inputId, 'file'));
    } else if (type.indexOf('number') !== -1) {
      field.appendChild(renderTextInput(option, propertyName, inputId, 'number'));
    } else if (type.indexOf('date') !== -1) {
      field.appendChild(renderTextInput(option, propertyName, inputId, 'date'));
    } else if (type.indexOf('color') !== -1) {
      field.appendChild(renderTextInput(option, propertyName, inputId, 'color'));
    } else {
      field.appendChild(renderTextInput(option, propertyName, inputId, 'text'));
    }

    if (option.help_text) {
      var help = document.createElement('p');
      help.className = 'mellow-quick-add-aris__help';
      help.textContent = option.help_text;
      field.appendChild(help);
    }

    var error = document.createElement('p');
    error.className = 'mellow-quick-add-aris__error';
    error.dataset.mellowQuickAddFieldError = '';
    error.textContent = strings().fieldRequired;
    field.appendChild(error);

    return field;
  }

  function renderArisLabel(label, required, inputId) {
    var labelEl = document.createElement('label');
    labelEl.className = 'mellow-quick-add-aris__label';
    labelEl.setAttribute('for', inputId);
    labelEl.innerHTML = '<span>' + escapeHtml(label) + (required ? ' <span class="mellow-quick-add-aris__required" aria-hidden="true">*</span>' : '') + '</span>';
    return labelEl;
  }

  function applyCommonAttributes(input, option, propertyName, inputId) {
    input.id = inputId;
    input.name = 'properties[' + propertyName + ']';
    input.dataset.mellowQuickAddArisInput = '';

    if (option.placeholder) {
      input.placeholder = option.placeholder;
    }

    if (option.max_length) {
      input.maxLength = parseInt(option.max_length, 10);
    }

    if (option.min) {
      input.min = option.min;
    }

    if (option.max) {
      input.max = option.max;
    }

    if (option.allow_value) {
      input.dataset.mellowQuickAddAllowValue = String(option.allow_value).toLowerCase();
    }

    if (option.text_transform) {
      input.dataset.mellowQuickAddTextTransform = String(option.text_transform).toLowerCase();

      if (String(option.text_transform).toLowerCase().indexOf('upper') !== -1) {
        input.autocapitalize = 'characters';
        input.style.textTransform = 'uppercase';
      }
    }
  }

  function renderTextInput(option, propertyName, inputId, type) {
    var input = document.createElement('input');
    input.className = 'mellow-quick-add-aris__input';
    input.type = type;
    applyCommonAttributes(input, option, propertyName, inputId);
    bindArisInputRules(input);
    return input;
  }

  function renderTextarea(option, propertyName, inputId) {
    var textarea = document.createElement('textarea');
    textarea.className = 'mellow-quick-add-aris__textarea';
    applyCommonAttributes(textarea, option, propertyName, inputId);
    bindArisInputRules(textarea);
    return textarea;
  }

  function bindArisInputRules(input) {
    if (!input || input.type === 'file' || input.type === 'date' || input.type === 'color') {
      return;
    }

    input.addEventListener('input', function() {
      var currentValue = input.value || '';
      var nextValue = applyArisInputRules(currentValue, input.dataset.mellowQuickAddAllowValue, input.dataset.mellowQuickAddTextTransform);

      if (nextValue === currentValue) {
        return;
      }

      var selectionStart = input.selectionStart;
      var selectionEnd = input.selectionEnd;
      input.value = nextValue;

      if (typeof selectionStart === 'number' && typeof input.setSelectionRange === 'function') {
        var offset = currentValue.length - nextValue.length;
        input.setSelectionRange(Math.max(0, selectionStart - offset), Math.max(0, selectionEnd - offset));
      }
    });
  }

  function applyArisInputRules(value, allowValue, textTransform) {
    var nextValue = String(value || '');

    if (allowValue === 'only_letters') {
      nextValue = nextValue.replace(/[^a-zA-Z]/g, '');
    } else if (allowValue === 'only_letters_number' || allowValue === 'only_letters_numbers') {
      nextValue = nextValue.replace(/[^a-zA-Z0-9]/g, '');
    } else if (allowValue === 'only_numbers' || allowValue === 'only_number') {
      nextValue = nextValue.replace(/[^0-9]/g, '');
    }

    if (textTransform && textTransform.indexOf('upper') !== -1) {
      nextValue = nextValue.toUpperCase();
    } else if (textTransform && textTransform.indexOf('lower') !== -1) {
      nextValue = nextValue.toLowerCase();
    }

    return nextValue;
  }

  function renderSelect(option, propertyName, inputId) {
    var select = document.createElement('select');
    select.className = 'mellow-quick-add-aris__select';
    applyCommonAttributes(select, option, propertyName, inputId);

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = option.placeholder || strings().makeSelection;
    select.appendChild(placeholder);

    (option.option_values || []).forEach(function(value) {
      var optionEl = document.createElement('option');
      optionEl.value = value.value || '';
      optionEl.textContent = value.value || '';
      if (option.option_default_value && option.option_default_value === value.value_id) {
        optionEl.selected = true;
      }
      select.appendChild(optionEl);
    });

    return select;
  }

  function renderChoiceGroup(option, propertyName, inputId, inputType) {
    var group = document.createElement('div');
    group.className = 'mellow-quick-add-aris__choices';
    group.setAttribute('role', inputType === 'radio' ? 'radiogroup' : 'group');

    if (inputType === 'checkbox') {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + propertyName + ']';
      hidden.dataset.mellowQuickAddCheckboxValue = '';
      group.appendChild(hidden);
    }

    (option.option_values || []).forEach(function(value, index) {
      var choiceId = inputId + '-' + index;
      var wrapper = document.createElement('span');
      var input = document.createElement('input');
      var label = document.createElement('label');

      wrapper.className = 'mellow-quick-add-aris__choice';
      input.type = inputType;
      input.id = choiceId;
      input.value = value.value || '';
      input.dataset.mellowQuickAddArisInput = '';
      input.dataset.propertyName = propertyName;

      if (inputType === 'radio') {
        input.name = 'properties[' + propertyName + ']';
      } else {
        input.name = 'mellow-quick-add-checkbox-' + propertyName.replace(/[^a-zA-Z0-9_-]/g, '-');
      }

      if (option.option_default_value && option.option_default_value === value.value_id) {
        input.checked = true;
      }

      label.className = 'mellow-quick-add-aris__choice-label';
      label.setAttribute('for', choiceId);

      if (value.swatch && value.swatch.file_image_url) {
        var image = document.createElement('img');
        image.className = 'mellow-quick-add-aris__choice-image';
        image.src = value.swatch.file_image_url;
        image.alt = '';
        label.appendChild(image);
      }

      label.appendChild(document.createTextNode(value.value || ''));
      wrapper.appendChild(input);
      wrapper.appendChild(label);
      group.appendChild(wrapper);
    });

    group.addEventListener('change', function() {
      updateCheckboxProperties(group);
    });

    return group;
  }

  function updateCheckboxProperties(root) {
    root.querySelectorAll('[data-mellow-quick-add-checkbox-value]').forEach(function(hidden) {
      var group = hidden.closest('.mellow-quick-add-aris__choices');
      if (!group) {
        return;
      }

      var values = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]:checked')).map(function(input) {
        return input.value;
      });
      hidden.value = values.join(', ');
    });
  }

  function validateArisFields(form) {
    var isValid = true;
    updateCheckboxProperties(form);

    form.querySelectorAll('[data-mellow-quick-add-aris-field]').forEach(function(field) {
      var required = field.dataset.required === 'true';
      var fieldValid = true;
      var type = field.dataset.fieldType || '';
      var fieldInput = field.querySelector('[data-mellow-quick-add-aris-input]');

      if (fieldInput && fieldInput.value) {
        fieldInput.value = applyArisInputRules(fieldInput.value, fieldInput.dataset.mellowQuickAddAllowValue, fieldInput.dataset.mellowQuickAddTextTransform);
      }

      if (required) {
        if (type.indexOf('checkbox') !== -1) {
          fieldValid = !!field.querySelector('input[type="checkbox"]:checked');
        } else if (type.indexOf('radio') !== -1 || type.indexOf('button') !== -1 || type.indexOf('swatch') !== -1) {
          fieldValid = !!field.querySelector('input[type="radio"]:checked');
        } else if (type.indexOf('file') !== -1) {
          var fileInput = field.querySelector('input[type="file"]');
          fieldValid = !!(fileInput && fileInput.files && fileInput.files.length);
        } else {
          fieldValid = !!(fieldInput && String(fieldInput.value || '').trim());
        }
      }

      field.classList.toggle('has-error', !fieldValid);
      if (!fieldValid) {
        isValid = false;
      }
    });

    return isValid;
  }

  async function handleDrawerSubmit(event) {
    var form = event.target.closest(selectors.form);
    if (!form) {
      return;
    }

    event.preventDefault();

    var submit = form.querySelector(selectors.submit);
    var errorDisplay = form.querySelector(selectors.errorDisplay);

    if (!validateArisFields(form)) {
      var firstInvalid = form.querySelector('.has-error input, .has-error select, .has-error textarea');
      if (firstInvalid) {
        firstInvalid.focus({ preventScroll: false });
      }
      return;
    }

    clearFormError(errorDisplay);
    submit.disabled = true;
    submit.classList.add('is-loading');
    submit.setAttribute('aria-busy', 'true');
    submit.querySelector('[data-add-to-cart-text]').textContent = state.source === 'stack-builder' ? 'Adding to stack…' : strings().adding;

    try {
      var formData = new FormData(form);
      sanitizeFormData(formData);

      if (state.source === 'stack-builder') {
        var content = form.closest('[data-mellow-quick-add-content]');
        var productJson = form.querySelector('[data-product-json]');
        var product = productJson ? JSON.parse(productJson.textContent) : {};
        var variantId = String(formData.get('id') || '');
        var variant = (product.variants || []).find(function(item) {
          return String(item.id) === variantId;
        }) || {};
        var entries = [];

        formData.forEach(function(value, key) {
          entries.push([key, value]);
        });

        if (content) {
          product.handle = product.handle || content.dataset.mellowQuickAddProductHandle || '';
          product.url = product.url || content.dataset.mellowQuickAddProductUrl || '';
        }

        document.dispatchEvent(new CustomEvent('mellow:stack:item-selected', {
          detail: {
            builderRoot: state.stackBuilderRoot || (state.activeButton && state.activeButton.closest('[data-mellow-stack-builder]')),
            sourceButton: state.activeButton,
            product: product,
            variant: variant,
            variantId: variantId,
            price: variant.price,
            entries: entries
          },
          bubbles: true
        }));
        closeDrawer();
        return;
      }

      await addToCart(formData);
      await refreshCart(true);
      closeDrawer();
    } catch (error) {
      showFormError(errorDisplay, error && error.message ? error.message : strings().networkError);
    } finally {
      submit.disabled = false;
      submit.classList.remove('is-loading');
      submit.setAttribute('aria-busy', 'false');
      submit.querySelector('[data-add-to-cart-text]').textContent = state.source === 'stack-builder' ? 'Add to stack' : strings().addToBag;
    }
  }

  function sanitizeFormData(formData) {
    if (!formData.get('quantity')) {
      formData.set('quantity', '1');
    }

    Array.prototype.slice.call(formData.entries()).forEach(function(entry) {
      var key = entry[0];
      var value = entry[1];

      if (key.indexOf('properties[') === 0 && typeof value === 'string' && value.trim() === '') {
        formData.delete(key);
      }
    });
  }

  async function addToCart(formData) {
    var routes = getRoutes();
    var hasFile = false;

    formData.forEach(function(value) {
      if (value instanceof File && value.name) {
        hasFile = true;
      }
    });

    var options = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    };

    if (hasFile) {
      options.body = formData;
    } else {
      options.body = new URLSearchParams(formData).toString();
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }

    var response = await window.fetch(routes.cart + '/add.js', options);
    var data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || strings().networkError);
    }

    return data;
  }

  async function refreshCart(openCart) {
    var routes = getRoutes();
    var response = await window.fetch(routes.cart + '.js', {
      credentials: 'same-origin'
    });
    var cart = await response.json();

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: {
        cart: cart
      },
      bubbles: true
    }));

    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      bubbles: true
    }));

    if (openCart) {
      openCartDrawer();
    }

    return cart;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) {
      return;
    }

    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
      bubbles: false
    }));
  }

  function handleVariantChange(event) {
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    var content = event.target.closest('[data-mellow-quick-add-content]');
    if (!content) {
      return;
    }

    var availability = content.querySelector(selectors.availability);

    if (availability) {
      availability.textContent = variant && variant.available ? strings().inStock : strings().outOfStock;
    }
  }

  function showCardError(button, message) {
    var boundary = button.closest('[data-error-boundary]');
    var display = boundary ? boundary.querySelector('[data-error-display]') : null;
    if (display) {
      display.textContent = message;
    }
  }

  function showFormError(element, message) {
    if (element) {
      element.textContent = message;
    }
  }

  function clearFormError(element) {
    if (element) {
      element.textContent = '';
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  document.addEventListener('click', handleClick);

  window.MellowQuickAdd = {
    open: openSelectionDrawer,
    openForStack: openForStack,
    close: closeDrawer,
    refreshCart: refreshCart
  };
})();
